import { Component, Inject, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { BreadCrumbService } from '../../../components/breadcrumb-bar/breadcrumb-service';
import { ActivatedRoute, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { DialogComponent, Order_Service } from 'legalreflex-lib';
import { MatDialog } from '@angular/material/dialog';
import { LookupFailDialog } from './lookupFailDialog';

@Component({
    templateUrl: './search.html',
    styleUrls: ['./search.scss']
})
export class OrderSearch {

    public par: string = '';
    constructor(
        public pageTitleService: Title,
        private breadCrumbService: BreadCrumbService,
        protected route: ActivatedRoute,
        protected router: Router,
        protected orderService: Order_Service,
        protected dialog: MatDialog,
    
    ) {
        this.breadCrumbService.actions.next([])
        this.breadCrumbService.breadcrumbs.next([
            { label: 'Orders', url: '/order'},
            { label: 'Loading'}
        ]);
    }

    ngAfterViewInit(){
        this.route.queryParams.pipe(filter(params => params.id)).subscribe((params)=>{
            if(params.id) {
                this.par = params.id;
                setTimeout(()=>{this.search()}, 3000)
            }
        });
    }

    search(){
        if(this.par) {
            this.orderService.getByVendorId(this.par).subscribe((res)=>{
                console.info("VENDOR RESULTS:", res)
                if(res.uuid){
                    this.router.navigate(['order/' + res.uuid],{queryParams: {download:true}})
                }
            },(err:any)=>{
                console.debug("Request error:", err, err.internalError == 'Unauthorized');
                if(err){
                    this.dialog.open(LookupFailDialog,{data: {orderId:this.par}})
                }
            })
        }
    }
}
